import {
  ActionDeleteIcon,
  EditIcon,
  TableActionIcon
} from '@checkit/react-components/build/components/Icons';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';
import AlertDialog from '../../components/alert/AlertDialog';
import MaterialUiLink from '../../components/MaterialUiLink';
import { messages } from './CheckpointTypeList.translations';

interface CheckpointTypeActionsProps {
  displayName: string;
  code: string;
  onUpdate(): void;
  onDelete(): void;
}

export function CheckpointTypeActions({
  displayName,
  code,
  onUpdate,
  onDelete
}: CheckpointTypeActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const { formatMessage } = useIntl();

  const deleteModalContent = (
    <>
      {/* The default is <p>, but inside a modal we get ne*/}
      <Typography component="span">
        {formatMessage(
          messages['checkpointTypes.list.actions.delete.areYouSure'],
          {
            b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
            displayName
          }
        )}
      </Typography>
      <br />
      <br />
      <Typography component="span">
        {formatMessage(
          messages['checkpointTypes.list.actions.delete.description'],
          {
            i: (...chunks: ReactNode[]) => <i>{chunks}</i>
          }
        )}
      </Typography>
    </>
  );
  function handleOpenMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  function onAcceptDelete() {
    onDelete();
    setDeleteModalOpen(false);
  }

  function onCancelDelete() {
    setDeleteModalOpen(false);
  }

  function handleDelete() {
    setDeleteModalOpen(true);
    handleCloseMenu();
  }

  return (
    <>
      <IconButton
        aria-label={formatMessage(messages['checkpointTypes.list.actions'])}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
      >
        <TableActionIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleCloseMenu} component={MaterialUiLink} to={`/checkpointtypes/${code}`}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          {formatMessage(messages['checkpointTypes.list.update'])}
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <ActionDeleteIcon />
          </ListItemIcon>
          {formatMessage(messages['checkpointTypes.list.delete'])}
        </MenuItem>
      </Menu>
      <AlertDialog
        onAccept={onAcceptDelete}
        onCancel={onCancelDelete}
        open={deleteModalOpen}
        text={deleteModalContent}
        title={formatMessage(
          messages['checkpointTypes.list.actions.delete.modalTitle']
        )}
      />
    </>
  );
}
